<template>
    <div v-loading="$parentInfo.studentEducationalExperiences.loading">
        <!--添加-->
        <el-button @click="handleAddEducationalExperiences()">
            学生教育信息添加
        </el-button>

        <div style="margin-top: 15px">
            <vue-scroll :ops="$ops" :style="{'height': $parentInfo.clientHeight-650+$parentInfo.heightChange+'px'}">
                <table class="table"  v-loading="$parentInfo.studentEducationalExperiences.loading">
                    <thead>
                    <tr>
                        <th>编号</th>
                        <th>学校名称</th>
                        <th>入学时间</th>
                        <th>毕业时间</th>
                        <th>年级</th>
                        <th>班级</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in $parentInfo.studentEducationalExperiences.educationalExperiences" :key="item.id">
                        <td>{{item.id}}</td>
                        <td v-if="!item.school">学校未填写</td>
                        <td v-else>{{item.school.name}}</td>
                        <td>{{item.school_year}}</td>
                        <td>{{item.graduated_at}}</td>
                        <td v-if="!item.grade">年级未填写</td>
                        <td v-else>{{item.grade.name}}</td>
                        <td v-if="!item.student_class">班级未填写</td>
                        <td v-else>{{item.student_class.name}}</td>
                        <td>
                            <el-button size="mini" @click="StudentEducationalExperiencesDetail(item.id)">详情</el-button>
                            <el-button size="mini" @click="deleteStudentEducationalExperiences(item.id)"
                                       :loading="$parentInfo.studentEducationalExperiences.button_loading">删除
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </vue-scroll>
            <component @closeModal="$parentInfo.studentEducationalExperiences.page1=''"
                       v-bind:is="$parentInfo.studentEducationalExperiences.page1" keep-alive
                       :id="$parentInfo.studentEducationalExperiences.page_id"
                       :student_id="$parentInfo.student_id"></component>
        </div>
        <!--分页-->
        <div class="text-center m-t-10">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="$parentInfo.studentEducationalExperiences.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$parentInfo.studentEducationalExperiences.total">
            </el-pagination>
        </div>


    </div>
</template>
<style scoped>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
<script>
    export default {
        data() {
            return {}
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentEducationalExperiences.loading = true;
            this.handleShowEducationalExperiences()
        },
        methods: {
            handleShowEducationalExperiences(currentPage = 1, currentPageSize = 10) {
                //EducationalExperiences
                this.$wApi.send(this.$parentInfo.path, 'studentEducationalExperiences', {
                    'student_id': this.$parentInfo.student_id,
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                });
            },
            //删除
            deleteStudentEducationalExperiences(id) {
                this.$confirm('是否删除此条教育经历?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentEducationalExperiences.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'deleteEducationalExperiences', {
                        'educationalExperience_id': id,
                        'student_id': this.$parentInfo.student_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSizeChange(val) {
                this.$parentInfo.studentEducationalExperiences.currentPageSize = val;
                this.handleShowEducationalExperiences(this.$parentInfo.studentEducationalExperiences.currentPage, this.$parentInfo.studentEducationalExperiences.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.studentEducationalExperiences.currentPage = val;
                this.handleShowEducationalExperiences(this.$parentInfo.studentEducationalExperiences.currentPage, this.$parentInfo.studentEducationalExperiences.currentPageSize)
            },
            StudentEducationalExperiencesDetail(id) {
                this.$Win.openModal('Dialog_StudentEducationalExperiencesDetail', 700, 300, '教育经历详情', {
                    'id': id,
                });
            },
            handleAddEducationalExperiences() {
                this.$Win.openModal('Dialog_StudentAddEducationalExperiences', 700, 300, '添加学生教育信息');
            },
        }
    }
</script>
